import { useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, SlidersHorizontal } from "lucide-react";
import AddToScenarioDialog from "../planning/AddToScenarioDialog";

function PriorityMark({ priority }) {
  if (priority === "must_do") return <span className="w-2.5 h-2.5 bg-ember shrink-0" title="Must do" />;
  if (priority === "high") return <span className="w-2.5 h-2.5 border-2 border-ember shrink-0" title="High" />;
  return <span className="w-2.5 h-2.5 border border-sand-300 shrink-0" title="Someday" />;
}

export default function WishlistRadar({ items }) {
  const [scenarioFor, setScenarioFor] = useState(null);

  return (
    <div className="rounded-card border border-hairline bg-surface h-full flex flex-col" data-testid="wishlist-radar">
      <div className="px-5 py-4 border-b border-sand-200 flex items-center justify-between">
        <p className="label-tag">Wishlist radar</p>
        <Link to="/plan/wishlist" className="font-mono text-[10px] font-semibold uppercase tracking-wider text-ember hover:underline" data-testid="radar-manage-link">
          Manage →
        </Link>
      </div>

      {items.length === 0 ? (
        <div className="flex-1 flex flex-col items-center justify-center px-6 py-10 text-center">
          <p className="font-mono text-xs text-sand-400 tracking-widest mb-2">RADAR CLEAR</p>
          <p className="text-xs text-sand-500 mb-3">Nothing on the wishlist yet.</p>
          <Link to="/plan/wishlist" className="font-mono text-xs text-ember font-semibold uppercase tracking-wider hover:underline" data-testid="radar-add-link">
            Add something →
          </Link>
        </div>
      ) : (
        <ul className="divide-y divide-sand-100 flex-1">
          {items.map((it) => (
            <li key={it.id} className="px-5 py-3.5 flex items-start gap-3 hover:bg-sand-50 transition-colors group" data-testid={`radar-item-${it.id}`}>
              <div className="mt-1"><PriorityMark priority={it.priority} /></div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-sand-900 truncate">{it.title}</p>
                <p className="font-mono text-[11px] text-sand-500 truncate flex items-center gap-1.5 mt-0.5">
                  {it.location && (
                    <>
                      <MapPin size={10} className="shrink-0" />
                      <span className="truncate">{it.location}</span>
                      <span className="text-sand-300">·</span>
                    </>
                  )}
                  <span className="whitespace-nowrap">{it.when}</span>
                </p>
                {it.scenario_est?.cost != null && (
                  <Link
                    to="/plan/scenarios"
                    className="inline-block mt-1 font-mono text-[10px] uppercase tracking-wide px-1.5 py-0.5 border border-ember/40 text-ember hover:bg-ember/5 transition-colors"
                    title={`From scenario "${it.scenario_est.scenario_name}"`}
                    data-testid={`radar-est-${it.id}`}
                  >
                    est ${Number(it.scenario_est.cost).toLocaleString()} loaded
                  </Link>
                )}
              </div>
              {it.status === "planned" && (
                <span className="font-mono text-[10px] uppercase tracking-wider px-2 py-0.5 bg-[#F3E7D3] text-[#B07B2E] border border-[#E9D5AE] shrink-0">
                  Planned
                </span>
              )}
              <button
                onClick={() => setScenarioFor(it)}
                className="p-1 text-sand-300 hover:text-ember shrink-0 transition-colors"
                title="Add to scenario — see the fully-loaded cost"
                data-testid={`radar-scenario-${it.id}`}
              >
                <SlidersHorizontal size={13} />
              </button>
            </li>
          ))}
        </ul>
      )}
      {scenarioFor && <AddToScenarioDialog item={scenarioFor} onClose={() => setScenarioFor(null)} />}
    </div>
  );
}
